export default "__VITE_ASSET__CU3quGA8__"